export const DEFAULT_OPTIONS = {
    length: 4,
    type: 'default',
    withReadMore: true,
};
